<template>
  <section class="home-app-banner">
    <!-- Carrusel de campañas cuando el cliente tiene banners asignados -->
    <div v-if="banners.length" :id="carouselId" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner home-app-banner__inner">
        <div
          v-for="(item, i) in banners"
          :key="item.bannerCampaniaId"
          class="carousel-item"
          :class="{ active: i === 0 }"
        >
          <a :href="item.linkUrl" target="_blank" rel="noreferrer noopener">
            <img :src="item.bannerUrl" alt="" class="home-app-banner__image">
          </a>
        </div>
      </div>

      <template v-if="banners.length > 1">
        <button
          class="carousel-control-prev"
          type="button"
          :data-bs-target="'#' + carouselId"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true" />
          <span class="visually-hidden">Anterior</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          :data-bs-target="'#' + carouselId"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true" />
          <span class="visually-hidden">Siguiente</span>
        </button>
      </template>
    </div>

    <!-- Banner por defecto (diseño Figma) -->
    <img v-else :src="defaultBanner" alt="Ya está disponible la nueva App HIR Casa" class="home-app-banner__image">
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import * as utilidades from '@/utilidades'
import { Cliente } from '@/servicios/api'

withDefaults(defineProps<{
  banners?: Cliente.Models.BannerCampania[]
}>(), {
  banners: () => []
})

const carouselId = ref(`home-banners-${utilidades.generarId()}`)
const defaultBanner = new URL('../../assets/home/img_banner_app.png', import.meta.url).href
</script>

<style scoped>
.home-app-banner {
  background: #2f2d74;
  border-radius: 16px;
  overflow: hidden;
}

.home-app-banner__inner {
  border-radius: 16px;
}

.home-app-banner__image {
  width: 100%;
  height: auto;
  display: block;
}
</style>
